import React from 'react';
import PropTypes from 'prop-types';

import ReportCell from '../../../shared/agGrid/cellRenderers/ReportCell.component';

const ReportCellTruncatedRenderer = ({ value }) => (
  <ReportCell type={value.type} truncate>
    {value.data}
  </ReportCell>
);

ReportCellTruncatedRenderer.propTypes = {
  value: PropTypes.shape({
    data: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }),
};

export default ReportCellTruncatedRenderer;
